import type { ListBuilderList } from '../../../types';
import { createDefaultLocationColumns } from '../columns';
import { BASE_REQUIRED_FIELDS } from '../shared';

/**
 * All Locations list configuration
 * Complete list of all locations with type, capacity, and status information
 */
export const allLocationsList: ListBuilderList = {
	id: 'default-locations-all',
	cacheTTL: 600000,
	name: 'All Locations',
	type: 'default',
	active: true,
	sortOrder: 99,
	columns: createDefaultLocationColumns(),
	description:
		'Complete list of all locations with type, capacity, and status information',
	defaultSortId: 'column-location-code-asc',
	requiredFields: BASE_REQUIRED_FIELDS,
};
